import React from 'react';
import SVGInline from 'react-svg-inline';
import block from 'bem-cn';

import paykassmaSVG from './img/paykassma.svg';
import './Paykassma.scss';
import { useDispatch, useSelector } from 'react-redux';
import Input from 'components/Input';
import Button from 'components/Button';
import usePaykassma from 'features/payment/model/paymentPaykassma/usePaykassma';
import { initPaykassmaDeposit } from 'features/payment/redux/actions';

const b = block('paykassma');

const Paykassma = () => {
  const { locale } = useSelector(state => state.locale);
  const { actionProcessing } = useSelector(state => state.payment);
  const dispatch = useDispatch();

  const model = usePaykassma();

  const handleDeposit = () => {
    dispatch(initPaykassmaDeposit({
      amount: parseFloat(model.value),
      returnUrl: `${window.location.origin}/payment-frame-redirect`,
      paymentSystem: 'd17_l'
    }));
  };

  return (
    <div className={b()}>
      <SVGInline svg={paykassmaSVG} className={b('image').toString()} />

      <div className={b('inputs')}>
        <label className={b('field')}>
          <p className={b('label')}>
            {locale.paymentAmount}
          </p>
          <div className={b('input')}>
            <Input
              name="usdtAmount"
              value={model.value}
              callBack={e => model.setValue(e.target.value)}
              placeholder='0.00'
              type="number"
              measure="TND"
            />
          </div>
        </label>

        <label className={b('field')}>
          <p className={b('label')}>
            {locale.youWillGet}
          </p>
          <div className={b('input')}>
            <Input
              name="usdtAmount"
              value={model.calculatedValue}
              callBack={e => console.log(e)}
              placeholder='0.00'
              type="number"
              measure="TND"
              disabled
            />
          </div>
        </label>
      </div>

      <p className={b('depInfo')}>{locale.minDeposit}: {model.minMax.min}.00 TND</p>

      <p className={b('depInfo')}>{locale.maxDeposit}: {model.minMax.max}.00 TND</p>

      <p className={b('rate')}>{`${locale.rate} 100 TND = 333.3 TND ${locale.onYourBalance}`}</p>

      <div className={b('button')}>
        <Button
          disabled={model.disabled || actionProcessing}
          onClick={handleDeposit}
          text={locale.topUp2}
        />
      </div>
    </div>
  )
}

export default Paykassma;